export const chooseUsItems = [
  {
    id: 1,
    title: "10+ YEARS EXPERIENCE",
    imgSrc: "images/experience-icon.png",
    content:
      "Over the course of 10 years, we have built strong and trusting relationships with our clients, subcontractors and suppliers. We understand that partnering at every level is the key to a successful project.",
  },
  {
    id: 2,
    title: "PROFESSIONAL SERVICES",
    imgSrc: "images/services.png",
    content:
      "With over 10 years experience & real focus on the customer satisfaction, you can found less like that our company structure and quality.",
  },
  {
    id: 3,
    title: "GOOD MATERIALS",
    imgSrc: "images/good-material-icon.png",
    content:
      "We are always try to use best materials, you know that good quality materials highly cost but we minimize your cost.",
  },
];
